// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as DateUtils from './utils/DateUtils'
import * as utils from './utils/utils'
import "@/style/index.scss"

Vue.prototype.$baseUrl = 'https://www.jxhnznsb.com';

Vue.use(ElementUI)

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥
  // 详见 http://lbsyun.baidu.com/apiconsole/key
  ak: 'KT0XUsYmvQhpNxllL5LSMpK3SuwR18q6'
})

Vue.config.productionTip = false
Vue.prototype.DateUtils = DateUtils
Vue.prototype.utils = utils
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js